import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TituloComponent } from './titulo/titulo.component';
import { AccesibilityComponent } from './accesibility/accesibility.component';


@NgModule({
  declarations: [
    TituloComponent,
    AccesibilityComponent
  ],
  imports: [
    CommonModule
  ],
  exports: [
    TituloComponent,
    AccesibilityComponent
  ]
})
export class ComponentsModule { }
